import React, { ReactNode } from "react";
import { Search } from "lucide-react";

interface Props {
  title: string;
  children: ReactNode;
}
const SearchNotFoundComponent: React.FC<Props> = ({ children, title }) => {
  return (
    <div className="noresult">
      <div className="py-6 text-center">
        <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
        <h5 className="mt-2 mb-1">{title}</h5>
        {children}
      </div>
    </div>
  );
};

export default SearchNotFoundComponent;
